export default "__VITE_ASSET__DWYW8lbL__"